import { useTranslation } from 'react-i18next';

import type { IRestrictionsProps } from '@app/dashboard/types/innerLayout/payment_links/single_quick_link';
import {
  CUSTOMER_DETAILS_TYPES,
  SINGLE_PL_SECTIONS_DIMENSIONS,
} from '@app/dashboard/constants/payment-links/single-payments';

import { SectionLoader } from '../../../Loader';
import ExpirationDate from './components/ExpirationDate';
import UnlimitedPayments from './components/UnlimitedPayments';

import styles from './restrictions.module.scss';

const Restrictions = ({
  fields,
  setFields,
  fullPageStatus,
  customerDetailsType,
}: IRestrictionsProps) => {
  const { t } = useTranslation();
  return fullPageStatus.loading ? (
    <SectionLoader {...SINGLE_PL_SECTIONS_DIMENSIONS.RESTRICTIONS} />
  ) : (
    <div className={styles['restrictions']}>
      <p className={styles['restrictions__title']}>
        {t('innerLayout.paymentLinksCreationPages.labels.restrictions')}
      </p>
      {customerDetailsType === CUSTOMER_DETAILS_TYPES.MULTIPLE && (
        <UnlimitedPayments fields={fields} setFields={setFields} />
      )}
      <ExpirationDate fields={fields} setFields={setFields} />
    </div>
  );
};

export default Restrictions;
